






















































































































































import Placeholder from '@components/placeholders/TrackPlaceholder.vue'
import get from 'lodash/get'
import { ActivitiesByLocalDate, GroupedActivityItem } from '@/types/user/API/ReqRes/userActivity'
import { TrialTime } from '@/types/user'
import wrappers from '@/mixins/wrappers'
import WrappedLink from '@components/WrappedLink.vue'
import LogEntry from '@components/LogEntry.vue'
import TrialComment from '@components/TrialComment.vue'
import LogCard from '@components/LogCard.vue'
import moment from 'moment-timezone'
export default wrappers.extend({
  name: 'TrackStart',
  components: {
    Placeholder,
    WrappedLink,
    LogEntry,
    LogCard,
    TrialComment
  },
  data () {
    return {
      logs: {} as Record<string, GroupedActivityItem>,
      activeCardType: 'sleep',
      activeCardBackup: {} as GroupedActivityItem,
      showCommentForm: false
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.activeLog) {
      return next()
    }
    const cardKeysToCompare = [
      'sleepLevel',
      'painLevel',
      'activityLevel',
      'sleepNote',
      'painNote'
    ] as Array<keyof GroupedActivityItem>
    const cardUpdated = cardKeysToCompare.some(
      key => this.activeLog[key] !== this.activeCardBackup[key]
    )
    if (!cardUpdated) {
      next()
    }
    else {
      this.showLeaveConfirmation().then(
        (action: string) => {
          if (action === 'discard') {
            next()
          }
        }
      )
    }
  },
  computed: {
    goal (): string {
      return this.$store.getters['user/activities/goal']
    },
    assessment (): string {
      return this.$store.getters['user/activities/assessment']
    },
    loading (): string {
      return this.$store.getters['user/loading']
    },
    name (): string {
      return get(this.$store.getters['user/me'], 'firstName', '').trim()
    },
    trialTime (): TrialTime {
      return this.$store.getters['user/trialTime']
    },
    activitiesByLocalDate (): ActivitiesByLocalDate {
      return this.$store.getters['user/activities/groupedByLocalDate']
    },
    days (): Array<string> {
      const {
        today, start, end
      } = this.trialTime.moments
      const result = [] as Array<string>
      for (
        let day = start.clone();
        day.isSameOrBefore(today) && day.isSameOrBefore(end);
        day.add(1, 'day')
      ) {
        result.push(day.format('YYYY-MM-DD'))
      }
      return result.reverse()
    },
    logsAsArray (): Array<GroupedActivityItem> {
      return this.days.map(day => this.logs[day])
    },
    activeLog (): GroupedActivityItem {
      const incompleteLogs = (this.logsAsArray as Array<Required<GroupedActivityItem>>)
        .filter(
          log => {
            return log && !log.isComplete
          }
        ).sort(
          (a, b) => {
            return b.fromToday - a.fromToday
          }
        )
      return incompleteLogs[0]
    }
  },
  mounted () {
    this.logs = this.days.reduce(
      (acc, localDate) => {
        const {
          today, start
        } = this.trialTime.moments
        const day = moment(localDate)
        const editableSince = today.clone().subtract(1, 'day')
        const record: GroupedActivityItem = get(this.activitiesByLocalDate, localDate)
        const isComplete = Boolean(
          day.isBefore(editableSince) ||
          (
            record &&
            ['sleepLevel', 'painLevel', 'activityLevel'].every(
              key => Boolean(get(record, key))
            )
          )
        )
        const fromToday = day.diff(today, 'day')
        const dayInTrial = day.diff(start, 'day') + 1
        acc[localDate] = {
          ...record || {},
          localDate,
          isComplete,
          fromToday,
          dayInTrial
        }
        return acc
      }, {} as Record<string, GroupedActivityItem>
    )
  },
  methods: {
    backupUpdated (log: GroupedActivityItem) {
      this.activeCardBackup = log
    },
    logIsActive (log: GroupedActivityItem) {
      return this.activeLog && this.activeLog.fromToday === log.fromToday
    },
    toggleCommentField (toShow: boolean) {
      this.showCommentForm = toShow
    },
    logUpdated (log: GroupedActivityItem) {
      this.$set(this.logs, log.localDate, log)
    },
    typeUpdated (type: string) {
      this.activeCardType = type
    },
    getCardType (log: GroupedActivityItem) {
      return this.logIsActive(log)
        ? this.activeCardType
        : null
    },
    async showLeaveConfirmation () {
      const { action } = await this.showModal(
        this.$t('Track.Card.prompt.discard.message'),
        {
          title: this.$t('Track.Card.prompt.discard.title'),
          buttons: [
            {
              label: this.$t('actions.discard'),
              event: 'discard',
              class: 'dv-button dv-button--secondary dv-button--large'
            },
            {
              label: this.$t('actions.no'),
              event: 'no',
              class: 'dv-button dv-button--primary dv-button--large'
            }
          ]
        }
      )
      return action
    }
  }
})
